import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import LockOutlined from "@material-ui/icons/LockOutlined";
import CheckCircle from "@material-ui/icons/CheckCircle";
import ErrorIcon from "@material-ui/icons/Error";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import IconButton from "@material-ui/core/IconButton";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Clearfix from "components/Clearfix/Clearfix.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import Snackbar from "components/Snackbar/Snackbar.js";

import styles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.js";

const useStyles = makeStyles(styles);

const GRAPHQL_URL = (process.env.REACT_APP_API_URL || "http://localhost:5001") + "/graphql";

const CHANGE_PASSWORD = `
  mutation ChangePassword($password: String!, $email: String!) {
    changePassword(password: $password, email: $email)
  }
`;

function gql(query, variables) {
  const token = localStorage.getItem("token");
  return fetch(GRAPHQL_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token ? `Bearer ${token}` : "",
    },
    credentials: "include",
    body: JSON.stringify({ query, variables }),
  }).then((r) => r.json());
}

export default function ChangePassword() {
  const classes = useStyles();

  const [form, setForm] = useState({ newPassword: "", confirmPassword: "" });
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [saving, setSaving] = useState(false);
  const [notification, setNotification] = useState({ open: false, message: "", color: "success" });

  const handleChange = (field) => (e) => setForm((f) => ({ ...f, [field]: e.target.value }));

  const handleSave = async () => {
    if (form.newPassword.length < 6) {
      setNotification({ open: true, message: "Password must be at least 6 characters", color: "danger" });
      return;
    }
    if (form.newPassword !== form.confirmPassword) {
      setNotification({ open: true, message: "Passwords do not match", color: "danger" });
      return;
    }

    const email = localStorage.getItem("email") || "";
    setSaving(true);
    const { data, errors } = await gql(CHANGE_PASSWORD, {
      password: form.newPassword,
      email,
    });
    setSaving(false);

    if (errors || data?.changePassword === false) {
      setNotification({ open: true, message: errors?.[0]?.message || "Failed to change password", color: "danger" });
    } else {
      setForm({ newPassword: "", confirmPassword: "" });
      setNotification({ open: true, message: "Password changed successfully", color: "success" });
    }
  };

  return (
    <div>
      <Snackbar
        place="tr"
        color={notification.color}
        icon={notification.color === "success" ? CheckCircle : ErrorIcon}
        message={notification.message}
        open={notification.open}
        closeNotification={() => setNotification((n) => ({ ...n, open: false }))}
        close
      />
      <GridContainer justifyContent="center">
        <GridItem xs={12} sm={12} md={6}>
          <Card>
            <CardHeader color="rose" icon>
              <CardIcon color="rose">
                <LockOutlined />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>
                Change Password
              </h4>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={12}>
                  <CustomInput
                    labelText="New Password"
                    id="new-password"
                    formControlProps={{ fullWidth: true }}
                    inputProps={{
                      type: showNew ? "text" : "password",
                      value: form.newPassword,
                      onChange: handleChange("newPassword"),
                      autoComplete: "new-password",
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton size="small" onClick={() => setShowNew((v) => !v)}>
                            {showNew ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </GridItem>
                <GridItem xs={12}>
                  <CustomInput
                    labelText="Confirm New Password"
                    id="confirm-password"
                    formControlProps={{ fullWidth: true }}
                    inputProps={{
                      type: showConfirm ? "text" : "password",
                      value: form.confirmPassword,
                      onChange: handleChange("confirmPassword"),
                      autoComplete: "new-password",
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton size="small" onClick={() => setShowConfirm((v) => !v)}>
                            {showConfirm ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </GridItem>
              </GridContainer>
              <Button color="rose" className={classes.updateProfileButton} onClick={handleSave} disabled={saving}>
                {saving ? "Saving..." : "Change Password"}
              </Button>
              <Clearfix />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}
